import Footer from "../components/Footer";
import NavBar from "../components/Navbar/NavBar";
import ServiceDetail from "../components/ServiceDetail";
import Ai from "../images/ai.png";

export default function AiSolutions() {
  return (
    <>
        <NavBar />
        <ServiceDetail
          titleKey="services.s2_title"
          descriptionKey="services.s2_more"
          image={Ai}
          highlights={[
            "services.s2_point_1",
            "services.s2_point_2",
            "services.s2_point_3",
          ]}
        />
        <Footer />
    </>
  );
}
